const { REACT_APP_GRAPHQL_API_MK } = process.env;

// NOTES
// query GetVariantsProductShopifyOpenSearch() { // NAME HERE DOESNT MATTER
  // getAllVariantsOfProductHybrid() { // NAME HERE SAME AS RESOLVER - ALSO SAME AS RESPONSE

const url = `${REACT_APP_GRAPHQL_API_MK}/graphql`;
// const url = 'http://localhost:4000/graphql';

// GraphQL #START******************************************************************************************

// 1. Products Query Shopify Table (Shopify GraphQL)
const GET_PRODUCTS_QUERY = `
  query GetProductsByStoreIdShopify($first: Int!, $after: String, $search: String, $storeId: String!, $storeUrl: String) {
    productsByStoreIdShopify(first: $first, after: $after, search: $search, storeId: $storeId, storeUrl: $storeUrl) {
      edges {
        cursor
        node {
          id
          product_id
          title
          handle
          createdAt
          updatedAt
          images {
            id
            src
            altText
          }
          variantsCount {
            count
          }
          status
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

// 1. Products Query Shopify Table (Shopify GraphQL)
export const fetchProductsShopifyGraphQL = async (storeId, storeUrl, page, rowsPerPage, debouncedSearch, pageInfo) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: GET_PRODUCTS_QUERY,
        variables: {
          first: 100,
          after: page > 0 ? pageInfo.endCursor : null,
          search: debouncedSearch || null,
          storeId,
          storeUrl
        }
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.errors ? data.errors.map(error => error.message).join('\n') : 'Failed to fetch products');
    }
    
    return data.data.productsByStoreIdShopify;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error; // Re-throw to handle this error further up the call stack
  }
}

// 1. Products Query Bigcommerce Table (Bigcommerce GraphQL)
const GET_PRODUCTS_QUERY_BIGCOMMERCE = `
  query GetProductsByStoreUrlBigcommerce($first: Int!, $after: String, $search: String, $storeUrl: String) {
    productsByStoreUrlBigcommerce(first: $first, after: $after, search: $search, storeUrl: $storeUrl) {
      edges {
        cursor
        node {
          id
          product_id
          title
          handle
          createdAt
          updatedAt
          images {
            id
            src
            altText
          }
          variantsCount {
            count
          }
          status
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

// 1. Products Query Bigcommerce Table (Bigcommerce GraphQL)
export const fetchProductsBigcommerceGraphQL = async (storeUrl, page, rowsPerPage, debouncedSearch, pageInfo) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: GET_PRODUCTS_QUERY_BIGCOMMERCE,
        variables: {
          first: 100,
          after: page > 0 ? pageInfo.endCursor : null,
          search: debouncedSearch || null,
          storeUrl
        }
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.errors ? data.errors.map(error => error.message).join('\n') : 'Failed to fetch products');
    }
    
    return data.data.productsByStoreUrlBigcommerce;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error; // Re-throw to handle this error further up the call stack
  }
}

// 2. Product Variants Query (Hybrid - Shopify + OpenSearch)
const QUERY_PRODUCT_VARIANTS_HYBRID = `
  query GetVariantsProductShopifyOpenSearch($productId: ID!, $storeId: String!, $storeUrl: String) {
    getAllVariantsOfProductHybrid(productId: $productId, storeId: $storeId, storeUrl: $storeUrl) {
      product {
        id
        title
        handle
        status
        productExistsInLevar
      }
      variants {
        id
        title
        updatedAt
        image {
          id
          src
          altText
        }
        variant_id
        variant_image_url
        variant_title
        variant_id_raw
        availableForSale
        existsInLevar
        referer
        options {
          option_value
          option_name
          option_prop
        }
        model_3d_id
        static_viewer_0
        interactive_viewer_0
        static_vto_face_0
        interactive_vto_face_0
        interactive_absolute_ground_0
        interactive_absolute_wall_0
        interactive_absolute_lighting_0
        room_viewer_0
        ar_experience_type
        asset_theme
        billboard_status
        custom_button
        direct_qr
        pdp_variant_switch
        preload_viewer
        translation_inactive
        view_in_space_off
        deletedFromShopify
      }
    }
  }
`;

// 2. Product Variants Query (Hybrid - Shopify + OpenSearch)
export const fetchAllVariantsOfProductHybrid = async (productId, storeId, storeUrl) => {    
  productId = productId.substring(productId.lastIndexOf('_') + 1) ; // productId comes in needs to extract the productId from the string

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: QUERY_PRODUCT_VARIANTS_HYBRID,
        variables: {
          productId,
          storeId,
          storeUrl 
        }
      })
    });

    const data = await response.json();
    // console.log('data', data)
    if (!response.ok) {
      throw new Error(data.errors ? data.errors.map(error => error.message).join('\n') : 'Failed to fetch product variants');
    }
    return data;
  } catch (error) {
    console.error('Error fetching product variants:', error);
    throw error; // Re-throw to handle this error further up the call stack
  }
};

// 3. Single Variant Query (Hybrid - Shopify + OpenSearch)
const QUERY_SINGLE_VARIANT_HYBRID = `
  query GetSingleVariantShopify($productId: ID!, $variantId: String!, $storeId: String!, $storeUrl: String) {
    getSingleVariantHybrid(productId: $productId, variantId: $variantId, storeId: $storeId, storeUrl: $storeUrl) {
      id
      title
      updatedAt
      image {
        id
        src
        altText
      }
      variant_id
      variant_image_url
      variant_title
      variant_id_raw
      availableForSale
      existsInLevar
      referer
      model_3d_id
      static_viewer_0
      interactive_viewer_0
      static_vto_face_0
      interactive_vto_face_0
      interactive_absolute_ground_0
      interactive_absolute_wall_0
      interactive_absolute_lighting_0
      room_viewer_0
      ar_experience_type
      asset_theme
      billboard_status
      custom_button
      direct_qr
      pdp_variant_switch
      preload_viewer
      translation_inactive
      view_in_space_off
      product {
        id
        title
        handle
        status
      }
    }
  }
`;

// 3. Single Variant Query (Hybrid - Shopify + OpenSearch)
export const fetchSingleVariantHybrid = async (productId, variantId, storeId, storeUrl) => {
  productId = productId.substring(productId.lastIndexOf('_') + 1) ; // productId comes in needs to extract the productId from the string
  variantId = variantId.substring(variantId.lastIndexOf('_') + 1) ; // variantId comes in needs to extract the variantId from the string

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: QUERY_SINGLE_VARIANT_HYBRID,
        variables: {
          productId,
          variantId,
          storeId,
          storeUrl 
        }
      })
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.errors ? data.errors.map(error => error.message).join('\n') : 'Failed to fetch product variants');
    }
    return data;
  } catch (error) {
    console.error('Error fetching product variants:', error);
    return {
      statusCode: 400
    }
  }
}

// 4a. Products Query (OpenSearch)
const QUERY_PRODUCTS_OPENSEARCH = `
  query GetPaginatedProductsOpenSearch(
    $first: Int!
    $after: String
    $search: String
    $storeId: String!
    $sortField: String
    $sortOrder: String
  ) {
    productsByStoreIdOpenSearch(
      first: $first
      after: $after
      search: $search
      storeId: $storeId
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      edges {
        cursor
        node {
          _id
          id
          product_id
          product_id_raw
          product_title
          store_id
          store_title
          store_owner_uuid
          account_owner_uuid
          manufacturer_uuid
          xo_manufacturer_name
          image_url
          product_reference_url
          variant_reference_url
          platform
          mpn
          sku
          upc
          created_at
          variants
          referer
          levar_user_account_id
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;

// 4a. Products Query (OpenSearch)
export const fetchProductsOpenSearch = async ({
  first = 100,
  after = null,
  search = '',
  storeId,
  sortField = 'created_at',
  sortOrder = 'DESC'
}) => {

  // console.log('storeId', storeId);  // storeId = 'shp_92250145079'
  // storeUrl = 'levar-test-store-8.myshopify.com'
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_PRODUCTS_OPENSEARCH,
        variables: {
          first,
          after,
          search,
          storeId,
          sortField,
          sortOrder,
        },
      }),
    });

    const data = await response.json();
    
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }

    return data.data.productsByStoreIdOpenSearch;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

// 4b. Products Query With Connected Models (OpenSearch)
const QUERY_PRODUCTS_OPENSEARCH_WITH_CONNECTED_MODELS = `
  query GetPaginatedProductsOpenSearchWithConnectedModels(
    $first: Int!
    $after: String
    $search: String
    $storeId: String!
    $sortField: String
    $sortOrder: String
    $storeUrl: String
  ) {
    productsByStoreIdOpenSearchWithConnectedModels(
      first: $first
      after: $after
      search: $search
      storeId: $storeId
      sortField: $sortField
      sortOrder: $sortOrder
      storeUrl: $storeUrl
    ) {
      edges {
        cursor
        node {
          _id
          id
          product_id
          product_id_raw
          product_title
          store_id
          store_title
          store_owner_uuid
          account_owner_uuid
          manufacturer_uuid
          xo_manufacturer_name
          image_url
          product_reference_url
          variant_reference_url
          platform
          mpn
          sku
          upc
          created_at
          variants
          referer
          levar_user_account_id
          connectedModelsCount
          deleted
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      totalModelsConnected
      totalConnectedVariants
    }
  }
`;

// 4b. Products Query With Connected Models (OpenSearch)
export const fetchProductsOpenSearchWithConnectedModels = async ({
  first = 100,
  after = null,
  search = '',
  storeId,
  sortField = 'created_at',
  sortOrder = 'DESC',
  storeUrl
}) => {
  // console.log('storeId', storeId);
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_PRODUCTS_OPENSEARCH_WITH_CONNECTED_MODELS,
        variables: {
          first,
          after,
          search,
          storeId,
          sortField,
          sortOrder,
          storeUrl
        },
      }),
    });

    const data = await response.json();
    
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }

    return data.data.productsByStoreIdOpenSearchWithConnectedModels;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

// 5a. Get All Stores By Type Query (OpenSearch)
const QUERY_ALL_STORES_BY_TYPE_OPENSEARCH = `
  query GetAllStoresByTypeOpenSearch($first: Int, $after: String, $before: String, $search: String, $type: String) {
    getAllStoresByTypeOpenSearch(first: $first, after: $after, before: $before, search: $search, type: $type) {
      edges {
        node {
          id
          store_id
          created_at
          levar_user_account_id
          store_title
          platform
          store_domain
          store_url
          ecomm_domain
          timezone_name
          country_name
          country_code
          admin_email
          language
          uninstalled
          deleted
          dynamic_text_settings {
            custom_text_status
          }
          timezone
          timezone_key
          levar_email
          shopify_billing {
            capped_amount
            updated_at
            recurring_application_charge_id
            balance_used
            balance_remaining
            created_at
            billing_on
            fixed_price
            status
            trial_ends_on
            return_url
            decorated_return_url
          }
          stripe_billing {
            stripe_customer_id
          }
          store_status
          model_limit
          updated_at
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;

// 5a. Get All Stores By Type Query (OpenSearch)
export const fetchAllStoresByTypeOpenSearch = async ({
  first = 100,
  after = null,
  before = null,
  search = '',
  type
}) => {
  // console.log('type', type);
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_ALL_STORES_BY_TYPE_OPENSEARCH,
        variables: {
          first,
          after,
          before,
          search,
          type
        },
      }),
    });

    const data = await response.json();
    
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }

    return {
      ...data.data.getAllStoresByTypeOpenSearch,
      // Ensure totalCount is always a number, default to 0 if undefined
      totalCount: data.data.getAllStoresByTypeOpenSearch.totalCount || 0
    };
  } catch (error) {
    console.error(`Error fetching all stores by type: ${type}`, error);
    throw error;
  }
};

// 6. Get All Active Shopify Stores Query (OpenSearch)
const QUERY_ACTIVE_SHOPIFY_STORES_OPENSEARCH = `
  query GetActiveShopifyStores($first: Int, $after: String, $search: String, $status: String) {
  getActiveShopifyStores(first: $first, after: $after, search: $search, status: $status) {
    edges {
      node {
        id
        created_at
        store_id
        store_title
        store_domain
        uninstalled
        model_limit
        platform
        shopify_billing {
          status
          fixed_price
          trial_ends_on
          billing_on
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
`;

// 6. Get All Active Shopify Stores Query (OpenSearch)
export const fetchActiveShopifyStoresOpenSearch = async ({
  first = 100,
  after = null,
  before = null,
  search = '',
  status = 'active'
}) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_ACTIVE_SHOPIFY_STORES_OPENSEARCH,
        variables: {
          first,
          after,
          before,
          search,
          status
        },
      }),
    });

    const data = await response.json();
    
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }

    return {
      ...data.data.getActiveShopifyStores,
      // Ensure totalCount is always a number, default to 0 if undefined
      totalCount: data.data.getActiveShopifyStores.totalCount || 0
    };
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

// 8. Get Store Details Query (OpenSearch)
const QUERY_STORE_DETAILS_OPENSEARCH = `
query GetSingleStoreOpenSearch($storeUrl: String!) {
  getSingleStoreOpenSearch(storeUrl: $storeUrl) {
    id
    store_id
    created_at
    levar_user_account_id
    store_title
    platform
    store_domain
    store_url
    ecomm_domain
    timezone_name
    country_name
    country_code
    admin_email
    language
    uninstalled
    deleted
    dynamic_text_settings {
      custom_text_status
    }
    timezone
    timezone_key
    levar_email
    shopify_billing {
      capped_amount
      updated_at
      recurring_application_charge_id
      balance_used
      balance_remaining
      created_at
      billing_on
      fixed_price
      status
      trial_ends_on
      return_url
      decorated_return_url
    }
    model_limit
    updated_at
    stripe_billing {
      stripe_customer_id
    }
    store_status
    store_owner_uuid
  }
}
`;

// 8. Get Store Details Query (OpenSearch)
export const fetchStoreDetails = async (storeUrl) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_STORE_DETAILS_OPENSEARCH,
        variables: {
          storeUrl,
        },
      }),
    });

    const data = await response.json();
    console.log('data', data);
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.getSingleStoreOpenSearch;  

  } catch (error) {
    console.error('Error fetching store details:', error);
    throw error;
  }
};

// GraphQL #END******************************************************************************************
// ******************************************************************************************************

// ****************************************************************************************************
// USER_ALL GraphQL #START*****************************************************************************

// 1. Get Shopify User Details Query (RDS & Shopify Access Token)
const QUERY_SHOPIFY_STORE_USER_DETAILS_GRAPHQL = `
 query GetUserConnectedToShopifyStore($storeUrl: String!) {
  getUserConnectedToShopifyStore(storeUrl: $storeUrl) {
    success
    setupWizardState
    error
    user {
      id
      uuid
      user_shopify_url
      setup_wizard_state
      email
      created_at
    }
    tokenIsValid
    }
  }
`;

// 1. Get Shopify User Details Query (RDS & Shopify Access Token)
export const fetchShopifyUserDetails = async (storeUrl) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_SHOPIFY_STORE_USER_DETAILS_GRAPHQL,
        variables: {
          storeUrl,
        },
      }),
    });

    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.getUserConnectedToShopifyStore;  

  } catch (error) {
    console.error('Error fetching store details:', error);
    throw error;
  }
};

// 2. Get Custom User Details Query
const QUERY_CUSTOM_STORE_USER_DETAILS_GRAPHQL = `
 query GetUserConnectedToCustomStore($storeOwnerUUID: String!) {
  getUserConnectedToCustomStore(storeOwnerUUID: $storeOwnerUUID) {
    success
    error
    user {
      id
      store_owner_uuid
      account_owner_uuid
      email
      created_at
    }
  }
}
`;

// 2. Get Custom User Details Query
export const fetchCustomUserDetails = async (storeOwnerUUID) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_CUSTOM_STORE_USER_DETAILS_GRAPHQL,
        variables: {
          storeOwnerUUID,
        },
      }),
    });

    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.getUserConnectedToCustomStore;  

  } catch (error) {
    console.error('Error fetching store details:', error);
    throw error;
  }
};

// 3. Get Bigcommerce User Details Query (RDS)
const QUERY_BIGCOMMERCE_USER_DETAILS_GRAPHQL = `
query GetUserConnectedToBigCommerceStore($storeUrl: String!) {
  getUserConnectedToBigCommerceStore(storeUrl: $storeUrl) {
    success
    setupWizardState
    error
    user {
      id
      uuid
      user_shopify_url
      setup_wizard_state
      email
      created_at
    }
    tokenIsValid
  }
}
`;

// 3. Get Bigcommerce User Details Query (RDS)
export const fetchBigcommerceUserDetails = async (storeUrl) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_BIGCOMMERCE_USER_DETAILS_GRAPHQL,
        variables: {
          storeUrl,
        },
      }),
    });

    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.getUserConnectedToBigCommerceStore;  

  } catch (error) {
    console.error('Error fetching store details:', error);
    throw error;
  }
};

// USER_ALL GraphQL #END*******************************************************************************
// ****************************************************************************************************


// ****************************************************************************************************
// DELETE_ALL GraphQL #START***************************************************************************

// 1. DELTE ALL INFO SHOPIFY STORE
const QUERY_DELETE_ALL_DATA_SHOPIFY_GRAPHQL = `
  mutation DeleteAllDataShopify($id: ID!, $uuid: String!, $password: String!) {
    deleteAllDataShopify(id: $id, uuid: $uuid, password: $password) {
      success
      message
      deletedData {
        userAccounts
        userIntegration
        userStores
        userLevar
        cognitoResult
      }
    }
  }
`;

// 1. DELTE ALL INFO SHOPIFY STORE
export const deleteAllDataShopify = async (id, uuid, password) => {
  // console.log('id', id)
  // console.log('id', id.type);
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_DELETE_ALL_DATA_SHOPIFY_GRAPHQL,
        variables: {
          id,
          uuid,
          password
        },
      }),
    });

    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.deleteAllDataShopify;  

  } catch (error) {
    console.error('Error fetching store details:', error);
    throw error;
  }
};

// DELETE_ALL GraphQL #END*****************************************************************************
// ****************************************************************************************************


// ****************************************************************************************************
// ECOMMERCE_PROUDCT_VARIANT CONNECTED 3D MODEL GraphQL #START*****************************************

// 1. UPDATE MODEL TO PRODUCT VARIANT
const QUERY_UPDATE_MODEL_TO_PRODUCT_VARIANT_GRAPHQL = `
  mutation updateModelToProductVariantShopify($storeUrl: String!, $variantId: String!, $model3dId: String!, $modelType: String!) {
    updateModelToProductVariantShopify(storeUrl: $storeUrl, variantId: $variantId, model3dId: $model3dId, modelType: $modelType) {
      status
      message
    }
  }
`;

// 1. UPDATE MODEL TO PRODUCT VARIANT
export const updateModelToProductVariantShopify = async (dataToUpdate, storeUrl) => {
  console.log('dataToUpdate', dataToUpdate);
  // Extract model type and ID from the property name and value
  const modelEntry = Object.entries(dataToUpdate).find(([key, value]) => 
    key !== 'variant_id' && value // Find the first non-variant_id property with a value
  );

  if (!modelEntry) {
    throw new Error('No model data found in update payload');
  }

  const [modelType, model3dId] = modelEntry;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_UPDATE_MODEL_TO_PRODUCT_VARIANT_GRAPHQL,
        variables: {
          storeUrl,
          variantId: dataToUpdate.variant_id,
          model3dId,
          modelType,
        },
      }),
    });

    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.updateModelToProductVariantShopify;  // Fixed return value to match mutation name

  } catch (error) {
    console.error('Error updating model to product variant:', error);
    throw error;
  }
};

// ECOMMERCE_PROUDCT_VARIANT CONNECTED 3D MODEL GraphQL #END*******************************************


// ****************************************************************************************************
// WEBHOOKS #START*************************************************************************************

// 1. REMOVE SHOPIFY WEBHOOKS
const QUERY_MANAGE_SHOPIFY_WEBHOOKS_GRAPHQL_REMOVE = `
  mutation RemoveWebhooks($storeUrl: String!) {
    manageShopifyWebhooks(input: {
      storeUrl: $storeUrl
      operation: REMOVE
    }) {
      success
      removed {
        topic
        callbackUrl
        id
      }
      errors {
        topic
        error
      }
    }
  }
`;

// 1. ADD SHOPIFY WEBHOOKS
const QUERY_MANAGE_SHOPIFY_WEBHOOKS_GRAPHQL_ADD = `
  mutation AddWebhooks($storeUrl: String!) {
    manageShopifyWebhooks(input: {
      storeUrl: $storeUrl
      operation: ADD
    }) {
      success
      added {
        topic
        callbackUrl
        id
      }
      errors {
        topic
        error
      }
    }
  }
`
      
// 1. ADD SHOPIFY WEBHOOKS
export const addRemoveShopifyWebhooks = async (storeUrl, operation) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: operation === 'remove' ? QUERY_MANAGE_SHOPIFY_WEBHOOKS_GRAPHQL_REMOVE : QUERY_MANAGE_SHOPIFY_WEBHOOKS_GRAPHQL_ADD,
        variables: {
          storeUrl,
        },
      }),
    });

    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.manageShopifyWebhooks;  // Fixed return value to match mutation name

  } catch (error) {
    console.error(`Error ${operation} shopify webhooks:`, error);
    throw error;
  }
};

// 2. Test Shopify Webhooks
const QUERY_TEST_SHOPIFY_WEBHOOKS = `
  query TestShopifyWebHooks($storeUrl: String!) { 
    testShopifyWebhooks(storeUrl: $storeUrl) {
      success
      error
      webhooks {
        topic
        callbackUrl
      }
    }
  }
`;

// 2. Test Shopify Webhooks 
export const testShopifyWebhooks = async (storeUrl) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_TEST_SHOPIFY_WEBHOOKS,
        variables: {
          storeUrl,
        },
      }),
    });

    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.testShopifyWebhooks;
  } catch (error) {
    console.error('Error testing Shopify webhooks:', error);
    throw error;
  }
};

// 3. Test BigCommerce Webhooks
const QUERY_TEST_BIGCOMMERCE_WEBHOOKS = `
  query TestBigcommerceWebhooks($storeUrl: String!) {
    testBigcommerceWebhooks(storeUrl: $storeUrl) {
      success
      error
      webhooks {
        topic
        callbackUrl
      }
    }
  }
`;

// 3. Test BigCommerce Webhooks
export const testBigcommerceWebhooks = async (storeDomain) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_TEST_BIGCOMMERCE_WEBHOOKS,
        variables: {
          storeUrl: storeDomain,
        },
      }),
    });

    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.testBigcommerceWebhooks;
  } catch (error) {
    console.error('Error testing BigCommerce webhooks:', error);
    throw error;
  }
};


// MODELS 3D #START*************************************************************************************

// 1. Get All Models 3D By Store ID
const QUERY_GET_ALL_MODELS_3D_BY_STORE_ID = `
  query GetAllModels3DByStoreId(
    $storeId: String!,
    $first: Int,
    $after: String,
    $search: String,
    $sortField: String,
    $sortOrder: String
  ) {
    modelsByStoreIdWithConnectedVariantInfo(
      storeId: $storeId,
      first: $first,
      after: $after,
      search: $search,
      sortField: $sortField,
      sortOrder: $sortOrder
    ) {
     edges {
      cursor
      node {
        _id
        created_at
        updated_at
        ghost_title
        geo_type
        store_id
        self_service
        model_type
        ghost_variant_id
        ghost_client_title
        model_3d_id
        billboard_list {
          id
        }
        model_status
        activeVariantsCount
        deletedVariantsCount
        totalVariantsCount
      }
     }
     pageInfo {
      hasNextPage
      endCursor
     }
     totalCount
    }
  }
`;

// 1. Get All Models 3D By Store ID
  export const getAllModels3DByStoreId = async ({
    storeId,
    first = 50,
    after = null,
    search = '',
    sortField = 'created_at',
    sortOrder = 'DESC'
  }) => {
  try {
    // console.log("storeId", storeId)
    const response = await fetch(url, {
      method: 'POST',
      headers: {  
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_GET_ALL_MODELS_3D_BY_STORE_ID,
        variables: {
          storeId,
          first,
          after,
          search,
          sortField,
          sortOrder
        },
      }),
    });

    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.modelsByStoreIdWithConnectedVariantInfo;
  } catch (error) {
    console.error('Error fetching models 3D by store ID:', error);
    throw error;
  }
};

// 2. Get Single Model 3D By Model 3D ID
const QUERY_GET_SINGLE_MODEL_3D_BY_MODEL_3D_ID = `
  query GetSingleModel3DByModel3dId($model3dId: String!) {
    modelsByStoreIdOpenSearch(model3dId: $model3dId) {
      status
      message
      results {
        _id
        created_at
        updated_at
        ghost_title
        ghost_client_title
        loadout_id
        bundle
        animation_solo
        vertical_ar
        ardt
        geo
        geo_type
        ecommerce_variant_id
        asset_environment
        asset_background
        custom_spawn
        orbit_controls_angles
        use_custom_spawn
        store_id
        self_service
        model_type
        schema_3d
        ghost_variant_id
        model_3d_id
        model_status
        materials {
          name
          uuid
          material_type
          side
          depth_write
          transparent
          channels {
            base_color
            roughness
            metalness
            normal
            ambient_occlusion
            opacity
            transmission
            ior
            thickness
            emissive
            emissive_intensity
            base_color_map
            emissive_map
            base_color_name
          }
        }
      }
      total
    }
  }
`;

// Models 3D #END******************************************************************************************


const QUERY_GET_ALL_VARIANTS_BY_MODEL_3D_ID = `
  query GetAllVariantsByModel3dId($model3dId: String! $storeId: String!) {
    getProductVariantsOpenSearchWithConnectedModels(model3dId: $model3dId, storeId: $storeId) {
      status
      message
      variants {
        id
        product_title
        product_id
        variant_id
        variant_image_url
        variant_title
        variant_id_raw
        existsInLevar
        model_3d_id
        static_viewer_0
        interactive_viewer_0
        static_vto_face_0
        interactive_vto_face_0
        interactive_absolute_ground_0
        interactive_absolute_wall_0
        interactive_absolute_lighting_0
        room_viewer_0
        referer
        deleted
      }
    }
  }
`;

export const fetchAllVariantsByModel3dIdGQL = async (model3dId, storeId) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_GET_ALL_VARIANTS_BY_MODEL_3D_ID,
        variables: { 
          model3dId, 
          storeId 
        },
      }),
    });
    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.getProductVariantsOpenSearchWithConnectedModels;
  } catch (error) {
    console.error('Error fetching all variants by model 3D ID:', error);
    throw error;
  }
};

// 1. DELTE ALL INFO SHOPIFY STORE
const QUERY_ONBOARING_USER = `
  mutation OnboardingUserComplete($storeUrl: String, $storeOwnerUUID: String) {
    onboardingUserComplete(storeUrl: $storeUrl, storeOwnerUUID: $storeOwnerUUID) {
      success
      levarUser {
        id
        uuid
        user_shopify_url
        setup_wizard_state
        email
        created_at
        accepts_marketing
        first_name
        last_name
        address
        city
        zip
        state
        country
        business_name
        website_url
        phone_number
        stripe_id
        render
        feature_gate
        analytics_gate
        pipedrive_export
        account_id
        three_d
        ar
        social
      }
      customUser {
        id
        store_owner_uuid
        account_owner_uuid
        email
        created_at
      }
      error
    }
  }
`;

export const fetchOnboardingUser = async (storeUrl, storeOwnerUUID) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_ONBOARING_USER,
        variables: {
          storeUrl,
          storeOwnerUUID
        },
      }),
    });
    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.onboardingUserComplete;
  } catch (error) {
    console.error('Error fetching onboarding user:', error);
    throw error;
  }
};

// 1. UPDATE ALL VARIANTS IMPLEMENTATION
const QUERY_UPDATE_ALL_VARIANTS_IMPLEMENTATION_GRAPHQL = `
  mutation updateAllVariantsImplementation($storeId: String!, $implementations: ImplementationInput!) {
    updateAllVariantsImplementation(storeId: $storeId, implementations: $implementations) {
      status
      message
    }
  }
`;

// 1. UPDATE ALL VARIANTS IMPLEMENTATION
export const updateAllStoresVariantsImplementation = async (storeId, implementations) => {
  // console.log('Syncing implementations:', implementations);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_UPDATE_ALL_VARIANTS_IMPLEMENTATION_GRAPHQL,
        variables: {
          storeId,
          implementations: {
            asset_theme: implementations.asset_theme || '',
            direct_qr: !!implementations.direct_qr,
            translation_inactive: !!implementations.translation_inactive
          },
        },
      }),
    });

    const data = await response.json();
    if (data.errors) {
      throw new Error(data.errors.map(error => error.message).join('\n'));
    }
    return data.data.updateAllVariantsImplementation;

  } catch (error) {
    console.error('Error updating all variants implementation:', error);
    throw error;
  }
};